import React from 'react'

import { NotificationInfoFragment } from '@sketch/gql-types'

import { AddShareMemberPreview } from './AddShareMemberPreview'
import { CommentMentionPreview } from './CommentMentionPreview'
import { DownloadableAssetPreview } from './DownloadableAssetPreview'
import { RichPreviewBox, RichPreviewText } from './InboxPreview.styles'

interface InboxPreviewBodyProps {
  notification: NotificationInfoFragment
}

export const InboxPreviewBody = ({ notification }: InboxPreviewBodyProps) => {
  if (
    notification.__typename === 'CommentNotification' ||
    notification.__typename === 'MentionNotification'
  ) {
    return <CommentMentionPreview notification={notification} />
  }

  if (notification.__typename === 'DownloadableAssetRenderedNotification') {
    return <DownloadableAssetPreview notification={notification} />
  }

  if (notification.__typename === 'AddShareMemberNotification') {
    return <AddShareMemberPreview notification={notification} />
  }

  return (
    <RichPreviewBox>
      <RichPreviewText>Rich Summary / Preview</RichPreviewText>
    </RichPreviewBox>
  )
}
